import Alert from '@storeblocks/alert';
import styled from 'styled-components';

export const AlertWrapper = styled.div`
  margin-bottom: 32px;
  max-width: 528px;
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

export const SubmissionAlert = styled(Alert)`
  margin-bottom: 48px;
`;
